import React from "react";
import "../lifehacks/ArticleFull.css";

const CPFOnlineInstructions = () => {
  return (
    <div className="article-full">
      <h1 className="article-title">Как оформить CPF онлайн в Бразилии</h1>

      <p className="article-text">
        CPF — это налоговый идентификационный номер, который потребуется практически везде.
      </p>

      <div className="article-section">
        <h3 className="article-section-title">1. Заполнение анкеты</h3>
        <p className="article-text">
          Перейдите по ссылке и заполните форму:{" "}
          <a
            href="https://servicos.receita.fazenda.gov.br/Servicos/CPF/cpfEstrangeiro/Fcpf.asp"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            анкета Receita Federal
          </a>
          . Укажите свои данные, адрес проживания в Бразилии (можно использовать адрес забронированного жилья), а также электронную почту.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">2. Подготовка декларации</h3>
        <p className="article-text">
          Далее потребуется заполнить форму-декларацию:{" "}
          <a
            href="https://www.gov.br/receitafederal/pt-br/centrais-de-conteudo/formularios/cadastros/cpf-condicao-fiscal"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            декларация для иностранцев
          </a>
          . В ней тоже необходимо указать актуальный бразильский адрес и контактные данные.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">3. Сканирование документов</h3>
        <p className="article-text">
         Все документы нужно отсканировать:
        </p>
        <ul className="article-text list-disc list-inside">
          <li>фото заграничного паспорта (страница с данными),</li>
          <li>селфи с паспортом,</li>
          <li>анкета и декларация с подписью.</li>
        </ul>
        <p className="article-text">
          Объедините все в один PDF-файл и проследите, чтобы его вес не превышал 10 МБ. Иначе письмо не будет отправлено.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">4. Отправка заявки</h3>
        <p className="article-text">
          Готовый файл отправьте на электронную почту налоговой:{" "}
          <a
            href="mailto:atendimentorfb.09@rfb.gov.br"
            className="text-blue-600 underline"
          >
            atendimentorfb.09@rfb.gov.br
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default CPFOnlineInstructions;